import {
  TICKET_ATTACHMENTS_ALLOWED_FORMATS,
  TICKET_MAX_FILES_NUMBER,
  TICKET_MAX_SIZE_MB,
} from '@sib/config';
import {
  Button,
  FormTextField,
  FormTextarea,
  UploadingFilesList,
} from '@sib/ui';
import { TICKET_DROPZONE_CONFIG } from '@sib/utils';
import { BaseDialogForm, UploadDocumentsDropzone } from '@spendbrain/common';
import { useAppTranslation } from '@spendbrain/modules/tickets/hooks';
import { useTicketFileUploadStore } from '@spendbrain/stores/fileUploadStore';
import { TicketFormField, useCreateTicketForm } from './CreateTicketForm.utils';

export const CreateTicketForm = () => {
  const { t } = useAppTranslation();
  const fileStore = useTicketFileUploadStore();

  const { onCancel, onSubmit, formProps, filesErrors } = useCreateTicketForm();

  const {
    formState: { isSubmitting, isValid },
  } = formProps;

  const isFormValid = filesErrors.length === 0 && isValid;

  return (
    <BaseDialogForm
      onSubmit={onSubmit}
      SubmitButtonProps={{
        text: t('create'),
      }}
      className="flex h-full flex-col gap-3"
      cancelButton={
        <Button disabled={isSubmitting} variant="outline" onClick={onCancel}>
          {t('cancel')}
        </Button>
      }
      canSubmit={isFormValid}
      {...formProps}
    >
      <div className="border-border flex w-full flex-col gap-5 rounded-sm border p-3.5 shadow-md">
        <FormTextField
          name={TicketFormField.Subject}
          label={t('components.createTicketForm.fields.subject')}
          placeholder={t('filters.searchPlaceholder')}
          readOnly={isSubmitting}
        />
        <FormTextarea
          rows={5}
          className="resize-none"
          name={TicketFormField.Description}
          label={t('components.createTicketForm.fields.description')}
          placeholder={t('filters.searchPlaceholder')}
          readOnly={isSubmitting}
        />
      </div>
      <div className="border-border flex h-full w-full flex-col gap-3 rounded-sm border p-3.5 shadow-md">
        <UploadDocumentsDropzone
          fileUploadStore={fileStore}
          allowedFormats={TICKET_ATTACHMENTS_ALLOWED_FORMATS}
          maxFilesNumber={TICKET_MAX_FILES_NUMBER}
          maxFilesSize={TICKET_MAX_SIZE_MB}
          disabled={isSubmitting}
          dropzoneConfig={TICKET_DROPZONE_CONFIG}
        />
        <UploadingFilesList
          fileListClassName="max-h-[250px]"
          fileUploadStore={fileStore}
          dropzoneConfig={TICKET_DROPZONE_CONFIG}
          hideSensitiveActions
          prefetchDocumentMd5={false}
        />
        <div className="flex flex-col gap-2">
          {filesErrors.length > 0 &&
            filesErrors.map(error => (
              <div key={error} className="text-destructive text-sm">
                {error}
              </div>
            ))}
        </div>
      </div>
    </BaseDialogForm>
  );
};
